import { Box } from "@material-ui/core";
import CloseIcon from '@mui/icons-material/Close';
import { Button } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import SettlementCheckList from "./SettlementCheckList";

const SettlementChecklistModal = ({
  checkListData,
  checkListOpen,
  data,
  setCheckListData,
  setCheckListOpen,
  settlement_id,
  style,
}) => (      <Modal
        open={checkListOpen}
        onClose={() => setCheckListOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 300 }}
        style={{ overflow: "auto", display: "flex", justifyContent: "center", alignItems: "center" ,scrollbarWidth: "none"}}
      >
        <Fade in={checkListOpen}>
          <Box sx={style} style={{ textAlign: "center", width: "50%", height: "95vh", maxHeight:"95vh",overflow:"auto",scrollbarWidth: "none" }}>
            <SettlementCheckList
                    onChecklistChange={(data) => setCheckListData(data)}
                    settlementId={settlement_id}
                    claimStatus={data.claimStatus}
                    claimType={data.claimType}
                    checklistData={checkListData} // 👈 pass the pre-fetched data
                  />

            <Button onClick={() => setCheckListOpen(false)} variant="contained" color="primary" style={{marginTop:"10px"}}>
              <CloseIcon /> Close
            </Button>
          </Box>
        </Fade>
      </Modal>);

export default SettlementChecklistModal;
